import { ChangeDetectionStrategy, ChangeDetectorRef, Component } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { DomSanitizer, SafeUrl } from "@angular/platform-browser";
import { WidgetApiService } from "@shared/services/integrations/widget-api.service";
import { LogService } from "@shared/services/log.service";
import { TranslatePipe } from "@ngx-translate/core";
import { trustResourceUrl } from "@shared/helpers/SafeUrlHelper";

import { SpinnerComponent } from "../../elements/spinner/spinner.component";
import { FullscreenButtonComponent } from "../../elements/fullscreen-button/fullscreen-button.component";

@Component({
    selector: "my-generic-widget-wrapper",
    templateUrl: "generic.component.html",
    styleUrls: ["generic.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [SpinnerComponent, FullscreenButtonComponent, TranslatePipe]
})
export class GenericWidgetWrapperComponent {
    public isLoading = true;
    public canEmbed = false;
    public embedUrl: SafeUrl = null;

    constructor(
        widgetApi: WidgetApiService,
        activatedRoute: ActivatedRoute,
        sanitizer: DomSanitizer,
        private readonly logService: LogService,
        private readonly cdr: ChangeDetectorRef,
    ) {
        this.onInit(widgetApi, activatedRoute, sanitizer);
    }

    private onInit(widgetApi: WidgetApiService, activatedRoute: ActivatedRoute, sanitizer: DomSanitizer) {
        const params: any = activatedRoute.snapshot.queryParams;
        widgetApi
            .isEmbeddable(params.url)
            .then((result) => {
                this.embedUrl = trustResourceUrl(sanitizer, params.url);
                // A rejected URL (dangerous scheme) can't be embedded regardless of what the API says
                this.canEmbed = result.canEmbed && !!this.embedUrl;
                this.isLoading = false;
            })
            .catch((err) => {
                this.logService.error(err);
                this.canEmbed = false;
                this.isLoading = false;
            }).finally(() => {
                this.cdr.detectChanges();
            });
    }
}
